export const mapBoxToken =
  'pk.eyJ1Ijoia2FsbGViZXJ0ZWxsIiwiYSI6ImNqYmd6NzlyeTBnMHUzM3RnbHQ4cWVuZWMifQ.kc0z7LzEhKP5zQfLO8vrGQ';

export const locationStartRadius = 1000;

/**
 * this is duration to deselect an airport
 */
export const deselectDuration = 500;

/**
 * this is duration to transition to the airport and select it
 */
export const selectDelayDuration = 1500;

export const resizeDebounceTime = 100;
